<div class="flex flex-column gap pt-2">
    <div>{{ prefix + 'message.refValues' | translate }}</div>
    <app-number-input
        id="payment"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [min]="0"
        [disabled]="form()!.value.direct ?? false"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.paymentDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

    <app-number-input
        id="clients"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [min]="0"
        [disabled]="form()!.value.direct ?? false"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.clientsDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

    <app-switch-input
        id="direct"
        [form]="form()!"
        [label]="prefix + 'fields.direct'"
    ></app-switch-input>

    <app-number-input
        id="puroRef"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [disabled]="!form()!.value.direct"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.puroRefDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

    <app-number-input
        id="highCostPayment"
        [prefix]="prefix"
        style="max-width: 300px"
        [form]="form()!"
        [min]="0"
        icon="pi-info-circle"
        [pTooltip]="prefix + 'message.highCostPaymentDesc' | translate"
        tooltipPosition="bottom"
    ></app-number-input>

    <div>{{ 'service.payments.puro.message.metCoefficients' | translate }}:</div>
    @for (name of coefficients(); track name) {
        <app-check-input
            #coefficientCheck
            [attributes]="{ name }"
            class="align-self-start"
            [id]="name"
            [label]="name"
            (selectedValueChange)="setCoefficient(name, $event)"
        ></app-check-input>
    }
</div>
